import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';

export const ISSUES_SETTINGS_ROUTE_NAMES = new Set<string>([
	ROUTE_NAMES.GLOBAL_SETTINGS_CUSTOM_FIELDS,
	ROUTE_NAMES.SETTINGS_CMDB_FIELD_CONFIG,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUTS,
	ROUTE_NAMES.GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_STATUSES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_RESOLUTIONS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TIME_TRACKING,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_LINK_TYPES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_HIERARCHY,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_SUBTASKS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITIES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW,
	ROUTE_NAMES.GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES,
]);
